import { makeVar } from '@apollo/client';

import { TDateRange } from 'common/types';

// Variable to store the previous date filter for the portfolio
// This is used to prevent refetching portfolio because of unmounting
export const prevPortfolioDateFilterVar = makeVar<TDateRange | undefined>(
    undefined
);
